import { render, staticRenderFns } from "./PermissionGroups.vue?vue&type=template&id=01209756&scoped=true&"
import script from "./PermissionGroups.vue?vue&type=script&lang=js&"
export * from "./PermissionGroups.vue?vue&type=script&lang=js&"
import style0 from "./PermissionGroups.vue?vue&type=style&index=0&id=01209756&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01209756",
  null
  
)

export default component.exports